<template>
    
  <!-- ======= Header ======= -->
  <header id="header" class="header fixed-top d-flex align-items-center">

    <div class="logo-group d-flex align-items-center justify-content-between">
        <router-link to="/" class="logo d-flex align-items-center">
            <img :src="logoUrl || '/assets/img/sudevwanobg.png'" alt="Logo">
            <span class="d-none d-lg-block">| {{ companyShortName }}</span>
        </router-link>
        <i @click="toggleSidebar" class="bi bi-list toggle-sidebar-btn"></i>
    </div>
    <!-- End Logo -->

    <nav class="header-nav ms-auto">
        <ul class="d-flex align-items-center">

            <li class="nav-item dropdown pe-3">
                <a class="nav-link nav-profile d-flex align-items-center" href="#" data-bs-toggle="dropdown">
                    <img :src="user?.avatar_url ? getAssetUrl(user.avatar_url) : '/assets/img/sudevwa-nobg.png'" alt="Profile">
                </a><!-- End Profile Iamge Icon -->

                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                    <li>
                    <a class="dropdown-item d-flex align-items-center" data-bs-toggle="modal"  data-bs-target="#logoutModal" style="cursor: pointer;">
                        <i class="bi bi-box-arrow-right"></i>
                        <span>Sign Out</span>
                    </a>
                    </li>
                </ul><!-- End Profile Dropdown Items -->
            </li><!-- End Profile Nav -->

        </ul>
    </nav><!-- End Icons Navigation -->
  
    </header><!-- End Header -->


  
    <!-- Modal -->
    <div class="modal fade" id="logoutModal" tabindex="-1" aria-labelledby="logoutModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content p-3 text-center">

            <h5 class="modal-title mb-3" id="logoutModalLabel">Are you sure you want to logout?</h5>

            <Vue3Lottie  
                animationLink="/assets/logout.json"
                :height="200"
                :width="200"
                :loop="true"
                :autoPlay="true"
            />

            <div class="mt-4 d-flex gap-2">
                <!-- CANCEL -->
                <button 
                type="button" 
                class="btn btn-secondary w-50" 
                data-bs-dismiss="modal">
                Cancel
                </button>

                <!-- OK -->
                <button 
                type="button" 
                class="btn btn-danger w-50"
                @click="prosesLogout">
                Logout
                </button>
            </div>
            </div>
        </div>
    </div>

    <div 
    v-if="showLogoutSuccess" 
    class="logout-success-overlay"
    >
        <div class="illustration-container">
            <Vue3Lottie  
            animationLink="/assets/success.json"
            :height="200" 
            :width="200"
            :loop="false"
            :autoPlay="true"
            />
        </div>
    </div>

</template>
<script setup>
import { ref, onMounted } from 'vue';
import { Vue3Lottie } from 'vue3-lottie';
import { useAuth } from '@/composables/useAuth';
import { useSystem } from '@/composables/useSystem.js';
import NProgress from 'nprogress';

const { logoutUser, user } = useAuth();
const { companyShortName, logoUrl, fetchSystemIdentity, getAssetUrl } = useSystem();
const showLogoutSuccess = ref(false);

onMounted(() => {
    fetchSystemIdentity();
});

function toggleSidebar() {
    document.body.classList.toggle('toggle-sidebar');
}

async function prosesLogout() {
    try {
        NProgress.start();
        
        // Show success animation
        showLogoutSuccess.value = true;
        
        // Call logout from useAuth (will blacklist token and clear state)
        await logoutUser();
        
        // Animation will show, then redirect happens in logoutUser
        setTimeout(() => {
            showLogoutSuccess.value = false;
        }, 1500);
        
    } catch (error) {
        console.error('Logout error:', error);
    } finally {
        // Close modal
        const modalElement = document.getElementById('logoutModal');
        if (modalElement) {
            const modal = bootstrap.Modal.getInstance(modalElement);
            if (modal) {
                modal.hide();
            }
        }
        NProgress.done();
    }
}
</script>

<style scoped>
    .logout-success-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.6); /* efek sedikit blur */
    z-index: 9999;
    backdrop-filter: blur(3px);
    animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
    }

    .illustration-container {
    display: flex;
    justify-content: center;
    align-items: center;
    }

</style>